var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_1795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6434 20.95C16.8536 20.95 19.4559 17.8272 19.4559 13.975C19.4559 10.1228 16.8536 7 13.6434 7C10.4333 7 7.83093 10.1228 7.83093 13.975C7.83093 17.8272 10.4333 20.95 13.6434 20.95Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5652 30.2502C16.5189 28.1577 16 25.0002 19.4559 21.9964C18.5 21.5002 17.9447 21.7639 17.3634 22.1127C16.2009 22.8102 15.0384 23.1589 13.6434 23.1589C12.2484 23.1589 11.0859 22.8102 9.92342 22.1127C9.34217 21.8802 8.52842 21.7639 7.83092 22.1127C5.27342 23.1589 3.29717 24.9027 2.25092 26.9952C1.43717 28.5064 2.71592 30.2502 4.45967 30.2502H12C13.7437 30.2502 17.5652 30.2502 17.5652 30.2502Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0416,
    y1: 18.2114,
    x2: 29.5312,
    y2: 26.701,
    stroke: "#FF0000",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.9835,
    y1: 26.701,
    x2: 29.473,
    y2: 18.2114,
    stroke: "#FF0000",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_1795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.d47f50f7dc646f76ae8c15a7dcbfec4b.svg";
export { ForwardRef as ReactComponent };